import React, { FC } from 'react';
import { Button } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import Modal, {
    ModalFooter,
    ModalHeader,
} from '@/components/Common/Modal';
import styles from './PhoneMissingModal.module.scss';

interface PasswordMissingModalProps {
    isOpen: boolean;
    onCancel: () => void;
    senderEmail: string;
}

const PasswordMissingModal: FC<PasswordMissingModalProps> = ({
    isOpen,
    onCancel,
    senderEmail,
}) => {
    const { t } = useTranslation();
    const nameSpace = 'recipientPage';

    return (
        <Modal
            isOpen={isOpen}
            closeModal={onCancel}
            closable
        >
            <>
                <ModalHeader>
                    <div className={styles.title}>
                        {t(`${nameSpace}.OTPSteps.passwordMissing.title`)}
                    </div>
                </ModalHeader>
                <div className={styles.content}>
                    <div className={styles.message}>
                        {t(`${nameSpace}.OTPSteps.passwordMissing.message`)}
                    </div>
                    <div className={styles.message}>
                        <Trans
                            i18nKey={`${nameSpace}.OTPSteps.passwordMissing.contactSender`}
                            t={t}
                            tOptions={{ senderEmail }}
                        >
                            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                            Ask <strong>senderEmail</strong> to add password for you. They can do this quickly, and you'll get access right after!
                        </Trans>
                    </div>
                    <ModalFooter>
                        <div className={styles['buttons-container']}>
                            <Button
                                onClick={onCancel}
                                className={styles['cancel-button']}
                            >
                                {t(`${nameSpace}.OTPSteps.passwordMissing.cancel`)}
                            </Button>
                            <Button
                                onClick={onCancel}
                                type="primary"
                                className={styles['confirm-button']}
                            >
                                {t(`${nameSpace}.OTPSteps.passwordMissing.confirm`)}
                            </Button>
                        </div>
                    </ModalFooter>
                </div>
            </>
        </Modal>
    );
};

export default PasswordMissingModal;


